import {useEffect} from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
function useKeyUp(targetKey: string, callback: Function, deps: any[] = []) {
    // If released key is our target key then set to false
    const upHandler = (e: any) => {
        if (e.key === targetKey) {
            callback(e)
        }
    };
    // Add event listeners
    useEffect(() => {
        window.addEventListener("keyup", upHandler);
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener("keyup", upHandler);
        };
        // eslint-disable-next-line
    }, deps); // Empty array ensures that effect is only run on mount and unmount

}


export default useKeyUp
